import { faEdit, faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { getBlockIcon } from "src/cases/templates/caseBlocks/blockIcons";
import { CaseBlockConfigFormValue } from "src/cases/templates/formUtils/types";
import { Icon, IconButton } from "src/design-system/Icon";

type BlockConfigCardProps = {
  config: CaseBlockConfigFormValue;
  errored?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  onDelete?: () => void;
  ref?: React.Ref<HTMLDivElement>;
};

export const BlockConfigCard: React.FC<BlockConfigCardProps> = ({
  config,
  errored = false,
  isSelected = false,
  onSelect,
  onDelete,
  ref,
}) => {
  const icon = getBlockIcon(config.icon);

  return (
    <div
      ref={ref}
      className={twJoin(
        "flex h-full cursor-pointer flex-col rounded-lg bg-gray-100 p-3",
        isSelected && "border border-indigo-600",
        !isSelected && !errored && "border border-gray-200",
        !isSelected &&
          errored &&
          "border border-red-600 ring-2 ring-red-400/25",
      )}
      data-loc={`block-config-card-${config.key}`}
      onClick={onSelect}
    >
      <div className="flex items-center gap-1">
        {/* RGL drag handle - class "drag-handle" is required */}
        <div
          className="drag-handle cursor-grab active:cursor-grabbing"
          data-loc="reorder-handle"
          onClick={(e) => e.stopPropagation()}
        >
          <Icon icon={faGripDotsVertical} size="xs" />
        </div>
        {icon && <Icon icon={icon} size="xs" />}
        <span
          className={twJoin(
            "flex-1 truncate font-inter-normal-12px",
            config.title ? "text-gray-600" : "text-gray-400",
          )}
        >
          {config.title || "Untitled block"}
        </span>
        <div className="flex items-center gap-1">
          <IconButton
            dataLoc={`block-config-edit-${config.key}`}
            icon={faEdit}
            size="xs"
            onClick={(e) => {
              e.stopPropagation();
              onSelect?.();
            }}
          />
          {onDelete && (
            <IconButton
              dataLoc={`block-config-delete-${config.key}`}
              icon={faTrashCan}
              size="xs"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
